module.exports = __webpack_public_path__ + "img/20230609_204418.6dc95823.png";